import Axios from "axios";

/**
 * Whether an error is the rejection of a request that was aborted on purpose (e.g. because a
 * newer one superseded it). Those are not failures and must not be shown to the user.
 */
export function isAbortError(error: unknown): boolean {
  return Axios.isCancel(error)
    || (error instanceof DOMException && error.name === "AbortError");
}

/** The query string builder writes every key, so an unset value would arrive as the text "undefined" */
export function withoutUnsetParams(params: Record<string, unknown>): Record<string, unknown> {
  return Object.fromEntries(Object.entries(params).filter(([, value]) => value !== undefined && value !== null));
}
